export const getRandomFloat = (min, max) => (Math.random() * (max - min)) + min;
